import { fetchPoolProxies } from "@fd/common/api/fetchPoolProxies";
import useSWR from "swr";

export default function useProxiesInPool(poolId: number) {
  const { data, isLoading, error, mutate } = useSWR(
    ['proxies', poolId],
    () => fetchPoolProxies(poolId),
  );

  return {
    data,
    isLoading,
    error,
    mutate,
  };
}

